import React from "react";

const ComparisonTable = () => {
  const features = [
    { name: "Data Ownership", custom: "Full control, hosted privately", chatgpt: "Stored on OpenAI's servers" },
    { name: "Data Security", custom: "Enhanced with private hosting", chatgpt: "Depends on OpenAI's protocols" },
    { name: "Data Sharing", custom: "No external data sharing", chatgpt: "Data may be processed by OpenAI" },
    { name: "Customization", custom: "Fully tailored to your needs", chatgpt: "No customization" },
    { name: "Knowledge Base", custom: "Specific to your company data", chatgpt: "General-purpose, limited domain focus" },
    { name: "Response Accuracy", custom: "High for domain-specific queries", chatgpt: "Varies for niche topics" },
  ];

  return (
    <div className="max-w-6xl mx-auto my-12 p-6 bg-white shadow-2xl rounded-3xl border border-gray-300 backdrop-blur-lg">
      <h2 className="text-4xl font-extrabold text-center text-gray-900 mb-8">Custom GPT vs ChatGPT</h2>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse rounded-lg shadow-lg bg-opacity-90 backdrop-blur-lg">
          <thead>
            <tr className="bg-gradient-to-r from-indigo-500 to-blue-600 text-white text-lg md:text-xl">
              <th className="py-4 px-4 text-left rounded-tl-lg">Feature</th>
              <th className="py-4 px-4 text-center">Custom GPT (Self-Hosted AI)</th>
              <th className="py-4 px-4 text-center rounded-tr-lg">ChatGPT</th>
            </tr>
          </thead>
          <tbody>
            {features.map((feature, index) => (
              <tr
                key={index}
                className={`text-gray-900 text-md md:text-lg ${
                  index % 2 === 0 ? "bg-gray-100" : "bg-white"
                } hover:bg-gray-200 transition duration-200`}
              >
                <td className="py-4 px-4 font-semibold text-left">{feature.name}</td>
                <td className="py-4 px-4 text-green-700 font-medium text-center border-l border-gray-300">
                  {feature.custom}
                </td>
                <td className="py-4 px-4 text-red-600 font-medium text-center border-l border-gray-300">
                  {feature.chatgpt}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Responsive Mobile View */}
      
    </div>
  );
};

export default ComparisonTable;
